<template>
  <div>
    <div class="d-flex flex-column h-100">
      <div>
        <SystemBar />
      </div>
      <div class="flex-fill overflow-auto">
        <Info />
        <ViewHeader v-if="!formIsMain.isActive && mainPath !== $route.path"/>
        <Questionnaire />
      </div>
      <div>
        <OcularSign />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Info: () => import('@/views/home/components/Info.vue'),
    ViewHeader: () => import(/* webpackPrefetch: true */ '@/components/ViewHeader.vue'),
    Questionnaire: () => import('@/views/home/components/Questionnaire.vue'),
    SystemBar: () => import('@/components/SystemBar.vue'),
    OcularSign: () => import('@/components/OcularSign.vue')
  },
  computed: {
    streamingPlayer () {
      return this.$organization.streamingPlayer()
    },
    formIsMain () {
      return this.$organization.formIsMain()
    },
    mainPath () {
      return this.$store.state.widget.mainPath
    }
  }
})
export default class Index extends Vue {}
</script>
